export const WRAPPER_TO_GAME_CLIENT_EVENT_TYPES = {
  INITIALIZE_PARAMS: 'GL/INITIALIZE_HANDSHAKE_PARAMS',
  INITIALIZE_URL: 'GL/INITIALIZE_URL',
  IOS_SOFT_RELOAD: 'GL/IOS_SOFT_RELOAD',
  GEOLOCATION_MESSAGE: 'GL/GEOLOCATION_RESULT', // not sent by iOS,sent first to game launcher ios needs to send it or GC to listten to 'geolocationResult'
  GEOLOCATION_UPDATE: 'GL/GEOLOCATION_ANDROID_TOKEN_UPDATED',
  TRIGGER_GEOLOCATION: 'GL/TRIGGER_GEOLOCATION',
  AUTHENTICATION_TOKEN_UPDATE: 'GL/AUTHENTICATION_TOKEN_UPDATE',
  GAME_WINDOW_UI_ENABLED: 'GL/GAME_WINDOW_UI_ENABLED',
  RESUME_DETACHED_SESSION: 'GL/RESUME_DETACHED_SESSION',
  REQUEST_DETACH_SESSION_SNAPSHOT: 'GL/REQUEST_DETACH_SESSION_SNAPSHOT',
} as const;

export type WrapperToGameClientEventType =
  (typeof WRAPPER_TO_GAME_CLIENT_EVENT_TYPES)[keyof typeof WRAPPER_TO_GAME_CLIENT_EVENT_TYPES];

export function isWrapperToGameClientEventType(
  type: WrapperToGameClientEventType,
) {
  return Object.values(WRAPPER_TO_GAME_CLIENT_EVENT_TYPES).includes(type);
}
